import { Flex, InkTag, Text } from "@/atoms"
import { useTranslation } from "@/hooks/useTranslation"

import type { ConnectionStatusLabelProps } from "."

export const ConnectionStatusLabel = ({
  status
}: ConnectionStatusLabelProps) => {
  const { t } = useTranslation("translation", {
    keyPrefix: "deployments.cloudConnection"
  })

  return (
    <Flex align="center" gap={8}>
      <InkTag dot color={status.color} />
      <Text>{t(`status.${status.tKey}`)}</Text>
    </Flex>
  )
}
